import React,{useState,useEffect} from 'react'
import {useParams,useNavigate} from 'react-router-dom'
import EmailEditor from '../../helpers/email-editor/EmailEditor';
import useEmailEditorStore from '../../helpers/email-editor/utilities/emailEditorStore';
import { htmlExport } from '../../helpers/email-editor/utilities/htmlExport';
import templateService from '../../../services/template.service';
import {toast} from 'react-toastify'

function EditEmailTemplate() {
    const {templateId} = useParams()
    const [txtType, setTxtType] = useState("PREBOOKED_REMINDER");
    const [txtUsedBy, settxtUsedBy] = useState("CLINIC");
    const [txtSubject, setTxtSubject] = useState(null);
    const [loadJson, setLoadJson] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate()
    const { blocks, globalProperties, exportTemplate } = useEmailEditorStore()

      const handleTextChange = (event) => {
        setTxtSubject(event.target.value);
      };

    const exportHtml = () => {
        try {
          const html = htmlExport(blocks, globalProperties);
          const template = exportTemplate();
          const jsonString = JSON.stringify(template);
          
          const edata = {
            type: txtType,
            mediumType: "EMAIL",
            subjectLine : txtSubject,
            content: html,
            jsonContent : jsonString,
            usedBy: txtUsedBy,
          }
          
          templateService.saveEcxTemplate(1, edata)
          .then((res)=>{
            toast.success("Template Saved", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
          })
          .catch((err) => {
            toast.error("Cannot Save Template.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.log(err);
          });
        } catch (error) {
          toast.error("Error exporting template.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.error(error);
        }
      };
    
      useEffect(() => {
        if (templateId) {
          setIsLoading(true);
          templateService
            .getEcxTemplateById(1, templateId)
            .then((res) => {
              setTxtType(res.data.type);
              settxtUsedBy(res.data.usedBy);
              setTxtSubject(res.data.subjectLine);
              
              try {
                const jo = JSON.parse(res.data.jsonContent);
                setLoadJson(jo);
              } catch (error) {
                console.error("Error parsing JSON content:", error);
                toast.error("Error loading template.", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
              }
              setIsLoading(false);
            })
            .catch((err) => {
              console.log("Error while getting Eyeconx Template", err);
              toast.error("Error loading template.", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
              setIsLoading(false);
            });
        }
      }, [templateId]);
   
  
  const handleCancel = ()=>{
    navigate("/email-template")
  }
  
    return (
   <>  <div className="container container-xxl">
        <nav className="navbar mb-3 navbar-expand-lg rounded p-3" style={{backgroundColor:"#8b02ee"}}>
            <div className="container-fluid">
                        <div className="d-flex flex-column me-4">
                            <span className="navbar-brand" style={{color:"white"}}>Email Template</span>
                            <span className="" style={{color:"white"}}>{txtType && txtType}</span>
                        </div>
                      

                      <div className="d-flex justify-content-between align-items-center flex-grow-1">
                        <label htmlFor="" className="form-label me-2" style={{color:"white"}}>Subject</label>
                        <input type="text" className="form-control" value={txtSubject && txtSubject} onChange={handleTextChange} />
                      </div>
                      <div className='d-flex flex-row align-items-center'>
                     
                      <button className="btn btn-sm btn-warning ms-2" onClick={exportHtml}>Save</button>
                      <button className="btn btn-sm btn-success ms-2" onClick={handleCancel}>Cancel</button>
                      </div>
                    
              
               
            </div>
        </nav>
      
           
            <div className="row">
                <div className="col-12">
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{height: "80vh"}}>
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <EmailEditor loadjson={loadJson} />
                )}
                </div>
                {/*<div className="col-4">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Email Template</h4>
                            <span className="card-subtitle">Type : Welcome</span>

                           <div className="form-group">
                                <label htmlFor="" className="form-label">Subject</label>
                                <textarea name="" id="" rows="5" className="form-control"></textarea>
                           </div>
                            <div className="mt-2">
                            <span className="badge text-bg-primary">Primary</span>

                            </div>
                        </div>
                    </div>
    </div> */}
            </div>
        </div>
   </>
  )
}

export default EditEmailTemplate